import { injectable } from "inversify";

@injectable()
export default class CancelationMiddleware {
  private controller!: AbortController | null;

  handleSignal() {
    if (this.controller) {
      this.controller.abort();
    }

    this.controller = new AbortController();

    return this.controller.signal;
  }
}
